<template>

    <div class="stages-detail-page">
        <Header></Header>
        <section class="contact-section">
            <div class="container">
                <div class="row">
                    <div class="col-md-5" style="margin: 0 auto;">
                        <h2>New Stage</h2>
                        <form class="form" v-on:submit.prevent="uploadImgages" enctype="multipart/form-data">
                            <div class="input-field form-input">
                                <label for="your-title">Title *</label>
                                <input type="text" placeholder="Add a title" v-model="title" id="your-title" v-on:blur="titleFuntion(title)">
                                <p class="error-input" v-if="titleFlag">Title is required</p>
                            </div>
                            <div class="input-textarea-field form-input">
                                <label for="your-description">Stage Description *</label>
                                <textarea placeholder="Tell us about your stage..." id="your-description" v-model="description" v-on:blur="descriptionFuntion(description)" style="min-height: 150px;"></textarea>
                                <p class="error-input" v-if="descriptionFlag">Stage Description is required</p>
                            </div>

                            <div class="input-file-field form-input">
                                <p>Stage Image *</p>
                                <label for="video_image">
                                    <span>{{videoCoverImage}}</span>
                                    <span>Choose File</span>
                                </label>
                                <input type="file" id="video_image" ref="videoImageFile" v-on:change="handleVideoCoverUpload">
                            </div>
                            <div class="country-list mb-4">
                                <label>Country</label>
                                <v-select :options="$options.myJson" v-model="country" />
                            </div>
                            <div :class="{ 'city-list mb-4 ': citiesList.length > 1, 'city-list mb-4 disabled': citiesList.length <= 1 }">
                                <label>Event Location *</label>
                                <v-select :options="citiesList" v-model="eventLocation" v-on:blur="eventLocationFuntion(eventLocation)" />
                                <p class="error-input" v-if="eventLocationFlag">Event Location is required</p>
                            </div>
                            <div class="input-field form-input">
                                <label>Event Date *</label>
                                <datepicker placeholder="Event Date" v-model="date" id="event-date" @selected="dateSelected" format="MMMM d yyyy" required></datepicker>
                            </div>
                            <div class="input-field form-input" v-if="pastEvent">
                                <label for="youtubeurl">You Tube Link</label>
                                <input type="text" placeholder="You Tube Link" v-model="youtubeurl" id="youtubeurl">
                            </div>
                            <div class="input-field form-input">
                                <label for="rehersal-schedule">Rehersal Schedule *</label>
                                <input type="text" placeholder="Once a month" v-model="rehersalSchedule" id="rehersal-schedule" v-on:blur="rehersalScheduleFuntion(rehersalSchedule)">
                                <p class="error-input" v-if="rehersalScheduleFlag">Rehersal Schedule is required</p>
                            </div>
                            <div class="input-tags-field form-input">
                                <label>Skills <span></span></label>
                                <tags-input element-id="tags"
                                            v-model="selectedSkills"
                                            :only-existing-tags="true"
                                            :delete-on-backspace="true"
                                            :typeahead-hide-discard="true"
                                            placeholder="Add your skills"
                                            @tags-updated="skillsFuntion"
                                            :existing-tags="$options.skills"
                                            :typeahead="true"></tags-input>
                            </div>
                            <div class="modal-field form-input">
                                <label>Team Members Role *</label>
                                <a href="javascript:void(0)" data-toggle="modal" data-target="#teamrolemodal"><img src="@/assets/img/plus.svg"/> Add team members</a>
                                <div class="row role-heading" v-if="roleList">
                                    <div class="col-md-4">
                                        <h3>Role</h3>
                                    </div>
                                    <div class="col-md-4">
                                        <h3>Specialty</h3>
                                    </div>
                                    <div class="col-md-4">
                                        <h3>Remote/Local</h3>
                                    </div>
                                </div>
                                <div class="row role-choosed" v-if="roleList" v-for="(list, index) in roleList" v-bind:key="index">
                                    <div class="col-md-4">
                                        <h4>{{list.role}}</h4>
                                    </div>
                                    <div class="col-md-4">
                                        <h4 v-if="list.specialty">{{list.specialty}}</h4>
                                        <h4 v-if="!list.specialty">-</h4>
                                    </div>
                                    <div class="col-md-4">
                                        <h4 v-if="list.remote">Remote</h4>
                                        <h4 v-if="!list.remote">Local</h4>
                                    </div>
                                </div>
                            </div>
                            <div class="input-textarea-field form-input">
                                <progress-bar
                                        v-if="progressFlag"
                                        :options="options"
                                        :value="value"
                                />
                            </div>
                            <div class="input-submit">
                                <button type="submit" v-if="!FormSubmited">SUBMIT</button>
                                <span v-if="FormSubmited">SUBMIT...</span>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
        <!-- Modal -->
        <div class="modal fade" id="teamrolemodal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalCenterTitle">Add Team Members</h5>
                    </div>
                    <div class="modal-body">
                        <div class="row team-role-heading">
                            <div class="col-md-4">
                                <h3>Role</h3>
                            </div>
                            <div class="col-md-4">
                                <h3>Specialty</h3>
                            </div>
                            <div class="col-md-4">
                                <h3>Remote</h3>
                            </div>
                        </div>
                        <TeamRoleCreate @clicked="removeOne" :count="list" v-for="(list) in roleCount" v-bind:key="list" />
                        <a href="javascript:void(0)" class="add-more-role" v-on:click="addMore">Add additional team member</a>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                        <button type="button" class="btn btn-primary" data-dismiss="modal" v-on:click="saveChanges">Save</button>
                    </div>
                </div>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>
<style>
    @import "../assets/css/tagsinput.css";
</style>

<script>
    import Vue from 'vue'
    import Header from './Header'
    import Footer from './Footer'
    import TeamRoleCreate from './include/TeamRoleCreate'
    import contries from '@/assets/country.json'
    import cities from '@/assets/cities.json'
    import router from '../router'
    import $ from "jquery"
    import VoerroTagsInput from '@voerro/vue-tagsinput'
    import Datepicker from 'vuejs-datepicker'
    import axios from 'axios'
    import VueToast from 'vue-toast-notification'
    import 'vue-toast-notification/dist/index.css'
    import skills from '@/assets/skills.json'
    import moment from 'moment'
    Vue.use(VueToast)

    import vSelect from "vue-select";
    Vue.component("v-select", vSelect);
    import "vue-select/dist/vue-select.css";

    export default {
        name: 'CreateUpcomingStage',
        myJson: contries,
        myJsonCities: cities,
        skills: skills,
        components: {
            'Header': Header,
            'Footer': Footer,
            'TeamRoleCreate': TeamRoleCreate,
            'Datepicker': Datepicker,
            'tags-input': VoerroTagsInput
        },
        data () {
            var userdata = localStorage.getItem('cbs_usertoken')
            if(userdata){
                userdata = JSON.parse(userdata)
            } else {
                router.push({ name: 'Login' })
            }
            var options = {
                text: {
                    color: '#FFFFFF',
                    shadowEnable: true,
                    shadowColor: '#000000',
                    fontSize: 14,
                    fontFamily: 'Helvetica',
                    dynamicPosition: false,
                    hideText: false
                },
                progress: {
                    color: '#ccc',
                    backgroundColor: '#333333'
                },
                layout: {
                    height: 35,
                    width: 445,
                    verticalTextAlign: 61,
                    horizontalTextAlign: 43,
                    zeroOffset: 0,
                    strokeWidth: 30,
                    progressPadding: 0,
                    type: 'line'
                }
            }
            return {
                msg: 'Welcome to Your Vue.js App',
                value: 1,
                options: options,
                progressFlag: false,
                roleCount: 1,
                country: '',
                citiesList: ["Please select country first"],
                roleList: '',
                selectedSkills: [],
                date: '',
                tags: '',
                title: '',
                userData: userdata,
                titleFlag: false,
                eventLocation: '',
                eventLocationFlag: false,
                rehersalSchedule: '',
                rehersalScheduleFlag: false,
                description: '',
                youtubeurl: '',
                pastEvent: false,
                descriptionFlag: false,
                stageid: '',
                videoFile: 'Video file',
                FormSubmited: false,
                // videoImageFile: '',
                videoId: '',
                videoCoverImage: 'Image file',
                userId: userdata.user.id
            }
        },
        mounted () {
            let $this = this
            $('.country-list .vs__search').change(function (event) {
                setTimeout(function () {
                    $this.getCities()
                }, 300)
            });
            $('.country-list .vs__search').blur(function (event) {
                setTimeout(function () {
                    $this.getCities()
                }, 300)
            });
            // this.$insProgress.start()
            // var roleData = localStorage.getItem('cbs_roleData')
            // if(roleData){
            //     roleData = JSON.parse(roleData)
            //     this.roleList = roleData
            // }
        },
        methods: {
            dateSelected: function(event){
                let selectedDate = moment(event).format('YYYYMMDD')
                let currentDate = moment(new Date()).format('YYYYMMDD')
                if(parseInt(currentDate) > parseInt(selectedDate)){
                    this.pastEvent = true
                } else {
                    this.pastEvent = false
                }
            },
            getCities: function (event) {
                this.citiesList = this.$options.myJsonCities[this.country]
            },
            saveChanges: function(){
                var roleBlock = []
                var roleObject = {}
                $('.role-blk').each(function () {
                    roleObject = {
                        role: $(this).find('select').val(),
                        specialty: $(this).find('.specialty').val(),
                        remote: $(this).find('.active-checkbox').length
                    }
                    roleBlock.push(roleObject)
                })
                this.roleList = roleBlock
                console.log(this.roleList)
                // localStorage.setItem('cbs_roleData', JSON.stringify(roleBlock))
            },
            addMore: function (event){
                this.roleCount = parseInt(this.roleCount) + 1
            },
            removeOne: function (event){
                $(event.target).closest('.role-blk').detach()
            },
            skillsFuntion(msg){
                if (!this.selectedSkills.length) {
                    this.skillsFlag = true
                } else {
                    this.skillsFlag = false
                    var tags = []
                    this.selectedSkills.map(function(value, key) {
                        tags.push(value.value)
                    })
                    this.tags = tags
                }
            },
            progressDelay: function(){
                var numberOfTimes = ''
                var delay = ''
                var $this = this
                if(this.value === 1){
                    numberOfTimes = 98
                    delay = 300
                } else {
                    numberOfTimes = 100 - this.value
                    delay = 10
                }
                for (let i = 0; i < numberOfTimes; i++) {
                    setTimeout( function () {
                        if($this.value < 100){
                            $this.value = $this.value + 1
                        }
                    }, delay * i)
                }
            },
            titleFuntion(msg){
                if (!msg) {
                    this.titleFlag = true
                } else {
                    this.titleFlag = false
                }
            },
            eventLocationFuntion(msg){
                if (!msg) {
                    this.eventLocationFlag = true
                } else {
                    this.eventLocationFlag = false
                }
            },
            rehersalScheduleFuntion(msg){
                if (!msg) {
                    this.rehersalScheduleFlag = true
                } else {
                    this.rehersalScheduleFlag = false
                }
            },
            descriptionFuntion(msg){
                if (!msg) {
                    this.descriptionFlag = true
                } else {
                    this.descriptionFlag = false
                }
            },
            createStageForm(){
                try {
                    axios.post('/createstage', {
                        title: this.title,
                        description: this.description,
                        country: this.country,
                        eventLocation: this.eventLocation,
                        youtubeurl: this.youtubeurl,
                        rehersalSchedule: this.rehersalSchedule,
                        date: this.date,
                        tags: this.tags,
                        roleList: this.roleList,
                        videoId: this.videoId,
                        userId: this.userId
                    },{
                        headers: {
                            "content-type": "application/json",
                            "x-api-key": this.userData.token
                        }
                    }).then(res => {
                        this.FormSubmited = false
                        this.progressDelay()
                        this.progressFlag = false
                        this.value = 1
                        Vue.$toast.open(
                            {
                                message: 'Stage created successfully!',
                                type: 'success',
                                position: 'top-right'
                                // all other options
                            }
                        )
                        this.title = this.description = this.file = this.videoFile = this.videoImageFile = this.videoCoverImage = ''
                        router.push({ path: '/stage/'+res.data._id })
                    }).catch(err => {
                        this.progressFlag = false
                        this.value = 1
                        this.FormSubmited = false
                        console.log(err)
                    })
                } catch (e) {
                    this.FormSubmited = false
                    console.log(e)
                }
            },
            handleFileUpload(){
                this.file = this.$refs.file.files[0]
                this.videoFile = this.$refs.file.files[0].name
                console.log(this.$refs.file.files[0].name)
            },
            handleVideoCoverUpload(){
                this.videoImageFile = this.$refs.videoImageFile.files[0]
                this.videoCoverImage = this.$refs.videoImageFile.files[0].name
                console.log(this.$refs.videoImageFile.files[0].name)
            },
            async uploadImgages () {
                if(this.title && this.description && this.videoImageFile){
                    this.FormSubmited = true
                    this.progressFlag = true
                    this.progressDelay()
                    const formData = new FormData()
                    // formData.append('videourl', this.file)
                    formData.append('videoImageFile', this.videoImageFile)
                    // formData.append('videoName', this.videoFile)
                    formData.append('videoImageName', this.videoCoverImage)
                    try {
                        axios.post('/videoupload', formData,{
                            headers: {
                                "content-type": "application/json",
                                "x-api-key": this.userData.token
                            }
                        }).then(res => {
                            this.videoId = res.data.videoId
                            this.createStageForm()
                            console.log(res)
                        }).catch(err => {
                            console.log(err)
                        })
                    } catch (e) {
                        console.log(e)
                    }
                } else {
                    Vue.$toast.open(
                        {
                            message: 'Please fill all the fields!',
                            type: 'error',
                            position: 'top-right'
                            // all other options
                        }
                    )
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/CreateUpcomingStage.vue